module.exports = __webpack_public_path__ + "6638a502619f55b730d8eff6a517d2db.svg";